module.exports = __webpack_public_path__ + "img/video-image.353a55ef.jpg";